import axios from './../http'

function query(data) {
    return axios.post('/sys/org/query', data);
}

function add(data) {
    return axios.post('/sys/org/add', data);
}

function update(data) {
    return axios.post('/sys/org/update', data);
}


function get(id) {
    return axios.get('/sys/org/get?id=' + id);
}

function select() {
    return axios.get('/sys/org/select');
}


function valid(data) {
    return axios.post('/sys/org/valid', data);
}
function invalid(data) {
    return axios.post('/sys/org/invalid' , data);
}


function getOptions(status) {
    if(status == undefined){
        status="";
    }
    return axios.post('/sys/org/getOptions?status='+status);
}


export default {
    query,
    select,
    get,
    add,
    update,
    valid,
    invalid,
    getOptions
}